import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { DataProvider } from "./contexts/DataContext";
import { UserRightsProvider } from "./contexts/UserRightsContext";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";

const keyToCamelCase = (key) => key.charAt(0).toLowerCase() + key.slice(1);

const convertToCamelCase = (obj) => {
  if (Array.isArray(obj)) return obj.map(convertToCamelCase);
  if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      acc[keyToCamelCase(key)] = convertToCamelCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

axios.interceptors.response.use((response) => {
  response.data = convertToCamelCase(response.data);
  return response;
});

const loginPath = "/login";
let userInfo = JSON.parse(localStorage.getItem("userInfo"));

function createLocationObserver(callback) {
  const handleLocationChange = () => {
    const location = {
      pathname: window.location.pathname,
      search: window.location.search,
    };
    callback(location);
  };

  // Override pushState and replaceState to listen to their calls
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function (...args) {
    originalPushState.apply(window.history, args);
    handleLocationChange();
  };

  window.history.replaceState = function (...args) {
    originalReplaceState.apply(window.history, args);
    handleLocationChange();
  };

  window.addEventListener("popstate", handleLocationChange);

  // Return a function to remove the event listener and restore original methods
  return () => {
    window.removeEventListener("popstate", handleLocationChange);
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
  };
}

createLocationObserver((location) => {
  userInfo = JSON.parse(localStorage.getItem("userInfo"));

  console.log("USER INFO", userInfo);
  console.log("PATHNAME", window.location.pathname);
  if (!userInfo && !location.pathname.includes(loginPath)) {
    // Replace the current URL without keeping it in history
    window.location.replace(loginPath);

    // Push the new URL to the history stack
    window.history.pushState(null, null, loginPath);
  }
});

console.log("USER INFO", userInfo);
console.log("PATHNAME", window.location.pathname);

if (!userInfo && !location.pathname.includes(loginPath)) {
  // Replace the current URL without keeping it in history
  window.location.replace(loginPath);

  // Push the new URL to the history stack
  window.history.pushState(null, null, loginPath);
} else {
  ReactDOM.render(
    <UserRightsProvider>
      <DataProvider>
        <App />
      </DataProvider>
    </UserRightsProvider>,
    document.getElementById("root")
  );
  //To Do Proper login
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}
